import { Chip, ChipProps } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { TsrctContractDemandStatus } from '@/generated/gql/graphql';
type ContractDemandStatusChipProps = {
  status: TsrctContractDemandStatus;
};

const colorFromStatus: Partial<Record<TsrctContractDemandStatus, ChipProps['color']>> = {
  [TsrctContractDemandStatus.IN_PROGRESS]: 'info',
  [TsrctContractDemandStatus.AWARDED]: 'success',
  [TsrctContractDemandStatus.CANCELLED]: 'error',
};

export const ContractDemandStatusChip = ({ status }: ContractDemandStatusChipProps) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'ContractDemandStatus' });
  return <Chip label={t(status)} color={colorFromStatus[status]} />;
};
